import React from 'react';
import CalciteButton from '../../shared/CalciteButton';

function CustomerNumberItemButton(props) {
	const buttonEl = React.useRef(null);

	React.useEffect(() => {
		var style = document.createElement('style');
		style.innerHTML = `
			button {
					align-items: start !important;
			}
		`;
		buttonEl.current.shadowRoot?.appendChild(style);
	}, []);

	return (
		<CalciteButton
			ref={buttonEl}
			width="full"
			scale="l"
			appearance="outline"
			kind={props.selected ? 'brand' : 'neutral'}
			onClick={props.onClick}
			className={props.className || undefined}>
			{props.children}
		</CalciteButton>
	);
}

export default CustomerNumberItemButton;
